import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class GuruImageCropperService {
    public show: BehaviorSubject<boolean>;

    public rounded: BehaviorSubject<boolean>;

    public cropperWidth: BehaviorSubject<number>;

    public cropperHeight: BehaviorSubject<number>;

    public fileToCrop: BehaviorSubject<File>;

    public callback: BehaviorSubject<(file: File, service?: any) => void>;

    public service: BehaviorSubject<any>;

    constructor() {
        this.show = new BehaviorSubject<boolean>(false);
        this.rounded = new BehaviorSubject<boolean>(false);
        this.cropperWidth = new BehaviorSubject<number>(50);
        this.cropperHeight = new BehaviorSubject<number>(50);
        this.fileToCrop = new BehaviorSubject<File>(undefined);
        this.callback = new BehaviorSubject<(file: File, service?: any) => void>(undefined);
        this.service = new BehaviorSubject<any>(undefined);
    }

    public fileToCropAsync = (): Observable<File> => this.fileToCrop.asObservable();
    public heightAsync = (): Observable<number> => this.cropperHeight.asObservable();
    public widthAsync = (): Observable<number> => this.cropperWidth.asObservable();
    public roundedAsync = (): Observable<boolean> => this.rounded.asObservable();
    public showAsync = (): Observable<boolean> => this.show.asObservable();

    public open(
        rounded: boolean,
        width: number,
        height: number,
        file: File,
        callback: (file: File) => void,
        service: any = undefined
    ) {
        this.show.next(true);
        this.rounded.next(rounded);
        this.cropperWidth.next(width);
        this.cropperHeight.next(height);
        this.fileToCrop.next(file);
        this.service.next(service);
        this.callback.next(callback);
    }

    public run(blob: Blob) {
        const file = new File([blob], this.fileToCrop.getValue()?.name);

        if (this.callback.getValue()) this.callback.getValue()(file, this.service.getValue());

        this.cancel();
    }

    cancel() {
        this.show.next(false);
        this.rounded.next(false);
        this.cropperWidth.next(50);
        this.cropperHeight.next(50);
        this.fileToCrop.next(undefined);
        this.service.next(undefined);
        this.callback.next(undefined);
    }
}
